export function stopEventPropagation(e: { stopPropagation: () => void }) {
  e.stopPropagation();
}
